var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DefaultLayout,{attrs:{"researchMenu":true,"researchOutboundMenu":true}},[_c(_setup.OutboundSearch)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }